  import { container, title } from "assets/jss/material-kit-react.js";

import imagesStyle from "assets/jss/material-kit-react/imagesStyles.js";
import red from '@material-ui/core/colors/red';

const primary = red[500]; // #f44336
const AnswerListPageStyle = {
  LeftToRight:{
"textAlign":"right",
"direction":"rtl"
  }
  };

export default AnswerListPageStyle;